import * as UserNotificationActionModal from 'raw-loader!src/app/public/app/shared/userNotifications/user-notifications-actions-modal.html';
import * as CandidateJobMatchCardReportModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-job-match-card-report-modal.html';
class UserNotificationsController {
    /*@ngInject*/
    constructor($rootScope, $state, $filter, $uibModal, $timeout, StorageService, planService, companyService, requisitionService, jobService, userRoleService, utilityService, debounceService, alertsAndNotificationsService, webSocketsService, dateTimeUtilityService, MESSAGECONSTANTS, notificationsService, sharedAjsService, modalService, outreachService, candidateService) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$filter = $filter;
        this.$uibModal = $uibModal;
        this.$timeout = $timeout;
        this.StorageService = StorageService;
        this.planService = planService;
        this.companyService = companyService;
        this.jobService = jobService;
        this.requisitionService = requisitionService;
        this.userRoleService = userRoleService;
        this.utilityService = utilityService;
        this.debounceService = debounceService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.webSocketsService = webSocketsService;
        this.dateTimeUtilityService = dateTimeUtilityService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.notificationsService = notificationsService,
            this.sharedAjsService = sharedAjsService;
        this.modalService = modalService;
        this.outreachService = outreachService;
        this.candidateService = candidateService;
    }
    $onInit() {
        //flags
        this.showShortMessagesFlag = true;
        this.isStaffingCompany = this.companyService.isStaffingCompany();
        //variables
        this.userId = this.$rootScope.userDetails.id;
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.searchObjectStartDate = null;
        this.searchObjectEndDate = null;
        this.searchNotifications = _.debounce(this.searchNotifications, 500);
        //objects
        this.filterObject = {};
        this.fullClientsList = [];
        this.selectedClients = [];
        this.fullRolesList = [];
        this.selectedRoles = [];
        this.fullReqNumList = [];
        this.selectedRequisitionNumbers = [];
        if (_.isUndefined(this.height)) {
            this.height = '400px';
        }
        if (_.isUndefined(this.width)) {
            this.width = '100%';
        }
        if (_.isUndefined(this.viewAllFlag)) {
            this.viewAllFlag = false;
        }
        if (_.isUndefined(this.viewAllMode)) {
            this.viewAllMode = 'modal';
        }
        if (_.isUndefined(this.context)) {
            this.context = 'global';
        }
        if (_.isUndefined(this.userNotificationControls)) {
            this.userNotificationControls = {};
        }
        if (_.isUndefined(this.numberOfNewNotifications)) {
            this.numberOfNewNotifications = 0;
        }
        if (_.isUndefined(this.showFilters)) {
            this.showFilters = false;
        }
        if (this.showFilters) {
            this._initializeDateAndTimePickersForFilters();
            this.getNotificationTypes();
            if (this.context == 'global') {
                this._getFilters();
            }
            // do not show short messages because this is the full notifications view.
            this.showShortMessagesFlag = false;
        }
        this.notificationsContainer = new NotificationsContainer(this.$rootScope, this.context, this.showShortNotification, this.searchObject, this.showFilters, this.fullView, this.alertsAndNotificationsService, this.notificationsService, this.isStaffingCompany, this.outreachService);
        this.userNotificationControls.setNewNotificationsAsViewed = this.notificationsContainer.setNewNotificationsAsViewed();
        this.filterObject.text = '';
        this._initializeNotificationReceive();
        this._setSearchEvents();
    }
    $onChanges(changes) {
        if (this.userNotificationControls && this.userNotificationControls.notificationClickCount > 0 && this.notificationsContainer) {
            this.notificationsContainer.isNotificationIconClicked = true;
            //enable infinite scrolling if icon is clicked and notifications exist
            if (this.notificationsContainer.notificationsExistFlag) {
                this.notificationsContainer.disableInfiniteScroll = false;
            }
            this.notificationsContainer.setNewNotificationsAsViewed();
        }
        this.userNotificationControls.notificationClickCount++;
    }
    _getFilters() {
        this.getNotificationTypes();
        this._getClientsOrBus(() => {
            this._getRoles("all");
            this.getRequisitionNumbers("all");
        });
    }
    _setSearchEvents() {
        $(document).ready(() => {
            $("#user-notifications-search-panel").hide();
            $(document).off("click", "#user-notifications-open-filter").on("click", "#user-notifications-open-filter", () => {
                $("#user-notifications-search-panel").animate({
                    height: 'toggle'
                });
            });
            // $("#userNotificationsClientName").keyup(this.debounceService.debounce(this.searchNotifications, 500));
            // $("#userNotificationsCandidateFirstName").keyup(this.debounceService.debounce(this.searchNotifications, 500));
            // $("#userNotificationsCandidateLastName").keyup(this.debounceService.debounce(this.searchNotifications, 500));
            // $("#userNotificationsRequisitionNumber").keyup(this.debounceService.debounce(this.searchNotifications, 500));
            // $("#userNotificationsJobTitle").keyup(this.debounceService.debounce(this.searchNotifications, 500));
        });
    }
    resetSearchFilters() {
        this.notificationsContainer.searchObject = new SearchObject(this.$rootScope.userDetails.company.companyId);
        //$("#timeBoundStartDate").datepicker("setDate", currentDate);
        this.searchObjectStartDate = '';
        this.searchObjectEndDate = '';
        this.searchNotifications();
    }
    ;
    searchNotifications() {
        // Check if there's already a request in progress
        if (this.notificationsContainer.busy) {
            // Search already in progress, skipping duplicate call
            return;
        }
        this.notificationsContainer.searchObject.page = "";
        this.notificationsContainer.currentPromise = null;
        this.notificationsContainer.disableInfiniteScroll = false;
        this.notificationsContainer.notificationsExistFlag = true;
        this.notificationsContainer.notifications = [];
        this.notificationsContainer.newNotifications = [];
        this.notificationsContainer.searchObject.clientOrBuIds = this.selectedClients.map(clientOrBu => clientOrBu.id);
        this.notificationsContainer.searchObject.roleNames = this.selectedRoles.map(role => role.name);
        this.notificationsContainer.searchObject.reqNumbers = this.selectedRequisitionNumbers.map(req => req.name);
        this.notificationsContainer.notificationCalledOnce = 0;
        this.notificationsContainer.getNext(this);
        // Wait until first getNext() finishes (busy = false)
        const trySecondLoad = () => {
            // Trigger getNext() when filtered count is less than original count (20)
            if (!this.notificationsContainer.busy) {
                // Now originalCount and filteredCount are available
                if (this.notificationsContainer.notificationCalledOnce <= 1 &&
                    this.notificationsContainer.originalNotificationCount > this.notificationsContainer.filteredNotificationCount) {
                    // Trigger second load safely
                    this.notificationsContainer.getNext(this);
                }
            }
            else {
                // Retry until busy becomes false
                this.$timeout(trySecondLoad, 100);
            }
        };
        this.$timeout(trySecondLoad, 100);
    }
    _initializeNotificationReceive() {
        this.webSocketsService.receive().then(null, null, (message) => {
            // message = {"notificationId":"2fc4ed38-0d23-47be-b88b-2b175b3bbb9e","companyId":"5c80ee5580ee22475e8e1dd4","clientOrBUId":null,"jobId":null,"candidateId":null,"jobMatchId":null,"eventId":"63a58e1980ee223127b85eec","alertId":null,"recipientId":"58776d60e4b0b349ba70cad8","recipientType":"USER","mode":"UI","status":null,"state":"NEW","text":"RESUME Scoring has finished for all '5' candidates","notifyOn":["GLOBAL"],"createdDate":"2022-12-23T11:16:41Z","lastModifiedDate":"2022-12-23T11:16:41Z","operation":"new","taggedText":"RESUME Scoring has finished for all <4dot5>'5'</4dot5> candidates","jbiTransactionId":null,"eventType":"REQUISITION_RE_RUN_SCORING","assessmentType":null,"testInvitationId":null,"redirect":null,"candidateScreenRedirect":null,"participantJoinDetails":null,"approverName":null,"participantRemovedBy":null,"feedbackEditEnabledUserName":null,"requesterName":null,"requesterAttendeeId":null,"primaryHostAttendeeId":null,"personInWaitingRoom":null,"candidateDtoMap":{"unProcessedCandidates":[{"candidateId":"63997cd680ee225dd7e9d890","firstName":"Daryl","lastName":"Ventura","phone":null,"email":"testvil@test.test","score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":"No eligible jobs for candidate","failedFileName":"58776d60e4b0b349ba70cad8-1671794067439-Daryl Ventura.doc","showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a58d9580ee223127b85cae","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false},{"candidateId":"5f2a80d780ee227f30d52d01","firstName":"Debbie","lastName":"Burgess","phone":null,"email":"testtt.0.2@4dot5.com","score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":"No eligible jobs for candidate","failedFileName":"58776d60e4b0b349ba70cad8-1671794067435-Debbie Burgess.docx","showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a58d9680ee223127b85caf","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false},{"candidateId":"63997cdd80ee225dd7e9d92d","firstName":"Dan","lastName":"Marks","phone":null,"email":"danlmarks@mchsi.com","score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":"No eligible jobs for candidate","failedFileName":"58776d60e4b0b349ba70cad8-1671794067423-Dan Marks.docx","showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a58d9680ee223127b85cb0","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false}],"candidates":[{"candidateId":"63a58d9880ee223127b85ccc","firstName":"Bhaskar","lastName":"Kanumuru","phone":null,"email":null,"score":1.0,"jobThresholdScore":50.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":null,"failedFileName":null,"showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a58d9380ee223127b85cac","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false},{"candidateId":"63a58d9980ee223127b85cd2","firstName":"Anusuya","lastName":"R","phone":null,"email":null,"score":1.0,"jobThresholdScore":40.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":null,"failedFileName":null,"showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a58d9380ee223127b85cad","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false},{"candidateId":"63997cd680ee225dd7e9d890","firstName":"Daryl","lastName":"Ventura","phone":null,"email":"testvil@test.test","score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":"No eligible jobs for candidate","failedFileName":"58776d60e4b0b349ba70cad8-1671794067439-Daryl Ventura.doc","showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a58d9580ee223127b85cae","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false},{"candidateId":"5f2a80d780ee227f30d52d01","firstName":"Debbie","lastName":"Burgess","phone":null,"email":"testtt.0.2@4dot5.com","score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":"No eligible jobs for candidate","failedFileName":"58776d60e4b0b349ba70cad8-1671794067435-Debbie Burgess.docx","showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a58d9680ee223127b85caf","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false},{"candidateId":"63997cdd80ee225dd7e9d92d","firstName":"Dan","lastName":"Marks","phone":null,"email":"danlmarks@mchsi.com","score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":"No eligible jobs for candidate","failedFileName":"58776d60e4b0b349ba70cad8-1671794067423-Dan Marks.docx","showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a58d9680ee223127b85cb0","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false}],"notProcessedCount":"0","uploadedCandidatesCount":"5","update":{"activeCandidatesCount":0,"passiveCandidatesCount":0,"matchedCandidateCount":5,"unMatchedCandidateCount":0,"justAddedCandidateCount":0,"notProcessedCandidateCount":0,"manuallyMatchedCandidateCount":0,"candidateList":[],"matchedCandidateIdAndNames":[{"candidateId":"63a58d9880ee223127b85ccc","candidateName":"Bhaskar Kanumuru"},{"candidateId":"63a58d9980ee223127b85cd2","candidateName":"Anusuya R"},{"candidateId":"63997cd680ee225dd7e9d890","candidateName":"Daryl Ventura"},{"candidateId":"5f2a80d780ee227f30d52d01","candidateName":"Debbie Burgess"},{"candidateId":"63997cdd80ee225dd7e9d92d","candidateName":"Dan Marks"}],"unMatchedCandidateIdAndNames":[],"candidatesSuspendedPeriod":0,"allowOverride":false}},"allowedToEditFeedback":false,"primaryHost":false, "requisitionScreenRedirect":{"screenName":null,"jobId":"65dc7c1b80ee22680c8b3e19","candidateId":"66065c9280ee2234553c8669","requisitionNumber":"REQ-5","candidateName":null,"candidateEmail":"vish77@gmail.com","candidateType":null,"vendorCandidate":false}};
            // message = {"notificationId":null,"companyId":"5c80ee5580ee22475e8e1dd4","clientOrBUId":null,"jobId":null,"candidateId":null,"jobMatchId":null,"eventId":"63a5858e80ee2209a139bd52","alertId":null,"recipientId":"58776d60e4b0b349ba70cad8","recipientType":"USER","mode":"UI","status":null,"state":"NEW","text":"RESUME Scoring has finished for all '2' candidates","notifyOn":["GLOBAL"],"createdDate":"2022-12-23T10:40:14Z","lastModifiedDate":"2022-12-23T10:40:14Z","operation":"new","taggedText":"RESUME Scoring has finished for all <4dot5>'2'</4dot5> candidates","jbiTransactionId":null,"eventType":"RESUME_SCORE_SYNC_COMPLETED","assessmentType":null,"testInvitationId":null,"redirect":null,"candidateScreenRedirect":null,"participantJoinDetails":null,"approverName":null,"participantRemovedBy":null,"feedbackEditEnabledUserName":null,"requesterName":null,"requesterAttendeeId":null,"primaryHostAttendeeId":null,"personInWaitingRoom":null,"candidateDtoMap":{"candidates":[{"candidateId":null,"firstName":null,"lastName":null,"phone":null,"email":null,"score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":null,"failedFileName":null,"showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":null,"newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false},{"candidateId":null,"firstName":null,"lastName":null,"phone":null,"email":null,"score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":null,"failedFileName":null,"showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":null,"newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false}],"notProcessedCount":"2","uploadedCandidatesCount":"2","update":{"activeCandidatesCount":0,"passiveCandidatesCount":0,"matchedCandidateCount":0,"unMatchedCandidateCount":0,"justAddedCandidateCount":0,"notProcessedCandidateCount":0,"manuallyMatchedCandidateCount":0,"candidateList":[],"matchedCandidateIdAndNames":[],"unMatchedCandidateIdAndNames":[],"candidatesSuspendedPeriod":0,"allowOverride":false}},"primaryHost":false,"allowedToEditFeedback":false}
            // message = {"notificationId":"b6f623e6-7f80-4182-8169-d9666d79b5d9","companyId":"5c80ee5580ee22475e8e1dd4","clientOrBUId":null,"jobId":"5da05e9e80ee2278a51d6a52","candidateId":null,"jobMatchId":null,"eventId":"63a5a0f880ee221b43818dfb","alertId":null,"recipientId":"58776d60e4b0b349ba70cad8","recipientType":"USER","mode":"UI","status":null,"state":"NEW","text":"RESUME Scoring has finished for all '2' candidates","notifyOn":["GLOBAL"],"createdDate":"2022-12-23T12:37:12Z","lastModifiedDate":"2022-12-23T12:37:12Z","operation":"new","taggedText":"RESUME Scoring has finished for all <4dot5>'2'</4dot5> candidates","jbiTransactionId":null,"eventType":"RESUME_SCORE_SYNC_COMPLETED","assessmentType":null,"testInvitationId":null,"redirect":null,"candidateScreenRedirect":null,"participantJoinDetails":null,"approverName":null,"participantRemovedBy":null,"feedbackEditEnabledUserName":null,"requesterName":null,"requesterAttendeeId":null,"primaryHostAttendeeId":null,"personInWaitingRoom":null,"candidateDtoMap":{"unProcessedCandidates":[{"candidateId":"5f30d07080ee2216f39a3be6","firstName":"Amy","lastName":"Buckner","phone":null,"email":"candidat7112@rightskillnow.com","score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":"No eligible jobs for candidate","failedFileName":"58776d60e4b0b349ba70cad8-1671798950803-Amy Buckner.docx","showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a5a0ab80ee221b43818dc5","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false},{"candidateId":"6171f16d80ee22473279c5ed","firstName":"AMIT","lastName":"BANSAL","phone":null,"email":"amitb1126@gmail.com","score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":"No eligible jobs for candidate","failedFileName":"58776d60e4b0b349ba70cad8-1671798950793-AMITHA BANSAL.doc","showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a5a0ab80ee221b43818dc4","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false}],"candidates":[{"candidateId":"5f30d07080ee2216f39a3be6","firstName":"Amy","lastName":"Buckner","phone":null,"email":"candidat7112@rightskillnow.com","score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":"No eligible jobs for candidate","failedFileName":"58776d60e4b0b349ba70cad8-1671798950803-Amy Buckner.docx","showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a5a0ab80ee221b43818dc5","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false},{"candidateId":"6171f16d80ee22473279c5ed","firstName":"AMIT","lastName":"BANSAL","phone":null,"email":"amitb1126@gmail.com","score":0.0,"jobThresholdScore":0.0,"jobId":null,"releaseDate":null,"suspendedMonths":0,"mobilePhoneCountryCodePresent":false,"failureReason":"No eligible jobs for candidate","failedFileName":"58776d60e4b0b349ba70cad8-1671798950793-AMITHA BANSAL.doc","showOverride":false,"allowOverride":false,"statusOfJobMatch":null,"allowManualMatch":false,"overrideFor":null,"releasedCandidateDetailDTO":null,"jobLeftCandidateDetailDTO":null,"transactionId":"63a5a0ab80ee221b43818dc4","newCandidate":false,"jobMatchManuallyCreated":false,"candidateMatchedToJob":false,"isCandidateCreationFailed":false}],"notProcessedCount":"0","uploadedCandidatesCount":"2","update":{"activeCandidatesCount":0,"passiveCandidatesCount":0,"matchedCandidateCount":2,"unMatchedCandidateCount":0,"justAddedCandidateCount":0,"notProcessedCandidateCount":0,"manuallyMatchedCandidateCount":0,"candidateList":[],"matchedCandidateIdAndNames":[{"candidateId":"5f30d07080ee2216f39a3be6","candidateName":"Amy Buckner"},{"candidateId":"6171f16d80ee22473279c5ed","candidateName":"AMIT BANSAL"}],"unMatchedCandidateIdAndNames":[],"candidatesSuspendedPeriod":0,"allowOverride":false}},"allowedToEditFeedback":false,"primaryHost":false};
            let performChangeFlag = false;
            // Do not show banner message under notifications
            if (message.notifyOn.indexOf('BANNER') != -1) {
                if (message.eventType === "PLAN_EXPIRATION_WARNING" || message.eventType === "CURRENT_PLAN_ACTIVATED") {
                    this._savePlanDetails();
                }
                else {
                    this._setCompanyState(message.text);
                }
            }
            else if (message.notifyOn.indexOf('SNACK_BAR') != -1 && message.eventType === "ASSESSMENTS_SYNC") {
                this._displayAssessmentsSyncMessage(message.taggedText);
            }
            //Show notifications
            else {
                if (this.context == 'global') {
                    if (message.notifyOn.indexOf('NO_GLOBAL') == -1) {
                        performChangeFlag = true;
                    }
                }
                else if (this.context == 'candidateCard') {
                    if (!_.isNull(message.candidateId) && (message.notifyOn.indexOf('CANDIDATE_CARD') != -1) && (message.candidateId == this.notificationsContainer.searchObject.candidateId)) {
                        performChangeFlag = true;
                    }
                }
                else if (this.context == 'candidateJobMatchCard') {
                    if (!_.isNull(message.jobMatchId) && (message.notifyOn.indexOf('CANDIDATE_JOB_CARD') != -1) && (message.jobMatchId == this.notificationsContainer.searchObject.jobMatchId)) {
                        performChangeFlag = true;
                    }
                }
                else if (this.context == 'requisitionCard') {
                    if (!_.isNull(message.jobId) && (message.notifyOn.indexOf('REQUISITION_CARD') != -1) && (message.jobId == this.notificationsContainer.searchObject.jobId)) {
                        performChangeFlag = true;
                    }
                }
                if (performChangeFlag) {
                    message = this.notificationsContainer.massageMessageData(message);
                    if (message.operation == 'new') {
                        let index = _.findIndex(this.notificationsContainer.notifications, {
                            notificationId: message.notificationId
                        });
                        if (index == -1) {
                            this.notificationsContainer.newNotifications.unshift(message);
                            this.numberOfNewNotifications = this.numberOfNewNotifications + 1;
                            this.notificationsContainer.notifications.unshift(message);
                            this.notificationsContainer.notificationsExistFlag = true;
                            // Update Notification
                            this.updateNotification(index, message);
                        }
                        if (message.notifyOn.indexOf('JOB_BOARD_SEARCH_FAILED') != -1) {
                            let title = 'Alert!';
                            let message = `We have reached the limit for the number of resume pulls from <b>${message.jobBoardName}</b>. Please talk to your administrator if you need to increase the resume pull limits for that specific Job Board.`;
                            this.alertsAndNotificationsService.showAlert(title, message, 'warning');
                        }
                    }
                    else if (message.operation == 'update' && message.state == "READ") {
                        let index = _.findIndex(this.notificationsContainer.notifications, {
                            notificationId: message.notificationId
                        });
                        if (index !== -1) {
                            this.notificationsContainer.notifications[index].state = message.state;
                            // Update Notification
                            this.updateNotification(index, message);
                            // remove if it exists in new notifications.
                            let removedArray = _.remove(this.notificationsContainer.newNotifications, {
                                notificationId: message.notificationId
                            });
                            if (removedArray.length > 0) {
                                this.numberOfNewNotifications = this.numberOfNewNotifications - 1;
                            }
                        }
                        else if (this.context == 'global') { //the read notification may not loaded on global icon notifications
                            this.numberOfNewNotifications = this.numberOfNewNotifications - 1;
                        }
                    }
                }
            }
        });
    }
    updateNotification(index, message) {
        if (message && message.eventType && message.eventType === 'JOB_BOARD_SEARCH_COMPLETED') {
            if (this.notificationsContainer && this.notificationsContainer.notifications && this.notificationsContainer.notifications[index]) {
                if (this.notificationsContainer.notifications[index].notificationId === message.notificationId) {
                    this.notificationsContainer.notifications[index].candidateDtoMap = message.candidateDtoMap ? message.candidateDtoMap : this.notificationsContainer.notifications[index].candidateDtoMap;
                }
            }
        }
    }
    _savePlanDetails() {
        this.planService.getCurrentPlan(this.$rootScope.userDetails.company.companyId, (data) => {
            this.$rootScope.userDetails.plan.planName = data.planHeaderDto.planName;
            this.$rootScope.userDetails.plan.startDate = moment(data.planHeaderDto.planStartDate);
            this.$rootScope.userDetails.plan.endDate = moment(data.planHeaderDto.planEndDate);
            this.$rootScope.userDetails.plan.planType = data.planHeaderDto.planType;
            this.$rootScope.userDetails.plan.message = this.planService.getPlanExpiryMessage(this.$rootScope.userDetails.plan.planType, this.$rootScope.userDetails.plan.endDate, true);
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _setCompanyState(text) {
        let index = text.substring(0, text.length - 3).lastIndexOf("'") + 1;
        let lastIndex = text.lastIndexOf("'");
        let companyState = text.substring(index, lastIndex);
        console.log(companyState);
        this.$rootScope.userDetails.company.companyState = companyState;
        this.companyService.setCompanyStateLabel();
        if (companyState == 'Hold' && !this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin()) {
            this.$rootScope.$emit("CallLogoutMethod", {
                logoutnow: true
            });
        }
        this.StorageService.set('userDetails', angular.copy(this.$rootScope.userDetails), {
            'expires': new Date(Date.now() + this.$rootScope.tokenvalidity)
        });
    }
    _displayAssessmentsSyncMessage(taggedHtmlText) {
        this.sharedAjsService.displayAssessmentsSyncMessage(this._getHighlightedNotificationHTML(taggedHtmlText));
    }
    onNotificationClicked($event, notification, notificationIndex) {
        // if(this.viewAllMode == 'navigate' || this.viewAllMode == 'modal') {
        if (this.showShortNotification) {
            this.expandNotification($event, notification, notificationIndex);
        }
        // trigger the regular marking notification as read.
        this.markNotificationAsRead($event, notification);
    }
    _showAssessmentReport(jobMatchId, assessmentType, testInvitationId) {
        this.$uibModal.open({
            animation: false,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: CandidateJobMatchCardReportModal.default,
            backdrop: 'static',
            windowClass: 'four-dot-five-modal-large',
            controller: ['$uibModalInstance', 'assessmentType', 'jobMatchId', 'testInvitationId', function ($uibModalInstance, assessmentType, jobMatchId, testInvitationId) {
                    let vm = this;
                    this.jobMatchId = jobMatchId;
                    this.assessmentType = assessmentType;
                    this.modalTitle = 'Technical Assessment Report';
                    this.context = "notification";
                    this.testInvitationId = testInvitationId;
                    if (assessmentType == 'ValueAssessment') {
                        this.modalTitle = 'Value Assessment Report';
                    }
                    this.closeModal = () => {
                        $uibModalInstance.dismiss('close');
                    };
                }],
            controllerAs: 'reportModal',
            size: 'lg',
            resolve: {
                assessmentType: () => {
                    return assessmentType;
                },
                jobMatchId: () => {
                    return jobMatchId;
                },
                testInvitationId: () => {
                    return testInvitationId;
                }
            }
        });
    }
    markNotificationAsRead($event, notification) {
        // show the full notification
        // notification.showShortMessageFlag = false;
        $event.stopPropagation();
        if (notification.state == 'NEW' || notification.state == 'VIEWED') {
            let stateObject = {
                notificationIds: [],
                state: 'READ'
            };
            stateObject.notificationIds.push(notification.notificationId);
            this.notificationsService.setNotificationsState(stateObject, (data) => {
                // do nothing. notification state change will be received as a push update and be handled in the this._initializeNotificationReceive above.
            }, (error) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    }
    performAction(actionType) {
        let selectedUserNotifications = [];
        angular.forEach(this.notificationsContainer.notifications, (val, key) => {
            if (val.selectedFlag) {
                selectedUserNotifications.push(val);
            }
        });
        if (selectedUserNotifications.length == 0) {
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>No Notifications Selected!</strong></div>",
                message: "Please select at least one notification to perform this action.",
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                }
            });
        }
        else {
            switch (actionType) {
                case 'markAsRead':
                    let stateObject = {
                        notificationIds: [],
                        state: 'READ'
                    };
                    if (this.notificationsContainer.selectAll) {
                        let markAsReadFilter = angular.copy(this.notificationsContainer.searchObject);
                        markAsReadFilter.excludedNotificationIds = this.notificationsContainer.notifications
                            .filter(notification => notification.selectedFlag == false)
                            .map(notification => notification.notificationId);
                        this.notificationsService.changeStateForNotificationsByFilter('READ', markAsReadFilter, (data) => {
                            // do nothing. notification state change will be received as a push update and be handled in the this._initializeNotificationReceive above.
                            angular.forEach(selectedUserNotifications, (val, key) => {
                                val.selectedFlag = this.notificationsContainer.selectAll;
                            });
                        }, (error) => {
                            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        });
                    }
                    else {
                        angular.forEach(selectedUserNotifications, (val, key) => {
                            stateObject.notificationIds.push(val.notificationId);
                        });
                        this.notificationsService.setNotificationsState(stateObject, (data) => {
                            // do nothing. notification state change will be received as a push update and be handled in the this._initializeNotificationReceive above.
                            angular.forEach(selectedUserNotifications, (val, key) => {
                                val.selectedFlag = this.notificationsContainer.selectAll;
                            });
                        }, (error) => {
                            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        });
                    }
                    break;
                default:
                // do nothing
            }
        }
    }
    _initializeDateAndTimePickersForFilters() {
        $(document).ready(() => {
            let currentDate = new Date();
            $('#userNotificationsStartDate').datepicker({
                format: "M d, yyyy",
                endDate: currentDate,
                weekStart: 1,
                autoclose: true
            });
            // set current date as default value
            //$("#timeBoundStartDate").datepicker("setDate", currentDate);
            $('#userNotificationsEndDate').datepicker({
                format: "M d, yyyy",
                endDate: currentDate,
                weekStart: 1,
                autoclose: true
            });
            $('#userNotificationsStartDate').datepicker().on('changeDate', (e) => {
                this._validateAndCorrectStartDateAndEndDate();
                this.notificationsContainer.searchObject.startDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.searchObjectStartDate));
                this.searchNotifications();
            });
            $('#userNotificationsEndDate').datepicker().on('changeDate', (e) => {
                this._validateAndCorrectStartDateAndEndDate();
                this.notificationsContainer.searchObject.endDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.searchObjectEndDate + ' 11:59:59 PM'));
                this.searchNotifications();
            });
        });
    }
    _validateAndCorrectStartDateAndEndDate() {
        if (!_.isNull(this.searchObjectStartDate) && this.searchObjectStartDate != '' && !_.isNull(this.searchObjectEndDate) && this.searchObjectEndDate != '') {
            let momentOfCurrentStartDate = moment(new Date(this.searchObjectStartDate));
            let momentOfCurrentEndDate = moment(new Date(this.searchObjectEndDate));
            if (momentOfCurrentEndDate.isBefore(momentOfCurrentStartDate, 'day')) {
                // make the 'end date' as 1 days greater than 'start date'
                let defaultEndDate = momentOfCurrentStartDate.add(1, 'd').toDate();
                $("#userNotificationsEndDate").datepicker("setDate", defaultEndDate);
            }
        }
    }
    viewAllNotifications() {
        if (this.viewAllMode == 'navigate') {
            this.$state.go('missioncontrol.notifications', { 'searchObject': this.notificationsContainer.searchObject, 'context': this.context }, { 'reload': true });
        }
        else if (this.viewAllMode == 'modal') {
            this.$uibModal.open({
                animation: false,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                template: UserNotificationActionModal.default,
                backdrop: 'static',
                keyboard: false,
                controller: ['$uibModalInstance', 'actionType', 'actionLabel', 'context', 'searchObject', 'closeCallback', 'jobTypeList', 'salaryDurationOptions', function ($uibModalInstance, actionType, actionLabel, context, searchObject, closeCallback, jobTypeList, salaryDurationOptions) {
                        let vm = this;
                        this.actionType = actionType;
                        this.actionLabel = actionLabel;
                        this.context = context;
                        this.searchObject = searchObject;
                        this.numberOfNewNotifications = 0;
                        this.userNotificationControls = {};
                        this.userNotificationControls.setNewNotificationsAsViewed = null;
                        this.jobTypeList = jobTypeList;
                        this.salaryDurationOptions = salaryDurationOptions;
                        this.closeModal = () => {
                            $uibModalInstance.close('cancel');
                        };
                    }],
                windowTopClass: 'user-notifications-modal-large',
                controllerAs: 'userNotificationsActionModal',
                size: 'lg',
                resolve: {
                    actionType: () => {
                        return 'viewAllNotifications';
                    },
                    actionLabel: () => {
                        return 'View All Notifications';
                    },
                    searchObject: () => {
                        let searchObject = JSON.parse(this.searchObject);
                        // change page size to 6
                        searchObject.size = 6;
                        return searchObject;
                    },
                    context: () => {
                        return this.context;
                    },
                    closeCallback: () => {
                        return this.init;
                    },
                    jobTypeList: () => {
                        return this.jobTypeList;
                    },
                    salaryDurationOptions: () => {
                        return this.salaryDurationOptions;
                    }
                }
            });
        }
    }
    selectAllNotifications() {
        angular.forEach(this.notificationsContainer.notifications, (notification, key) => {
            notification.selectedFlag = this.notificationsContainer.selectAll;
        });
    }
    onNotificationSelectionChange(selectedFlag) {
        // if(!selectedFlag) {
        //     this.notificationsContainer.selectAll = false;
        // }
    }
    expandNotification($event, notification, notificationIndex) {
        notification.showShortMessageFlag = !notification.showShortMessageFlag;
        $event.stopPropagation();
        if (!notification.showShortMessageFlag) {
            this.$timeout(() => {
                scrollIntoView(document.getElementById(notification.notificationId + "-" + notificationIndex), { behavior: "smooth", block: "end", scrollMode: "if-needed" });
            }, 200);
        }
    }
    _goToCandidateDocuments(notification) {
        let actionType = 'candidateBooklet';
        let actionLabel = notification.documentDtoMap.fullName + "'s" + ' Booklet';
        notification.documentDtoMap.isNotification = true;
        if (notification.documentDtoMap.eventType && notification.documentDtoMap.eventType == 'DOCUMENT_EMAIL_NOTIFICATION') {
            actionType = 'emailNotification';
            actionLabel = 'Details of Documents Emailed';
        }
        this.sharedAjsService.goToCandidateDocuments(actionType, actionLabel, notification.documentDtoMap);
    }
    goToResumeProcessedCandidates(notification) {
        let resumeProcessedModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            component: "uploadResumesProcessedCandidatesModal",
            windowTopClass: 'four-dot-five-modal-large',
            resolve: {
                candidatesCount: () => {
                    return notification.candidateDtoMap;
                },
                jobId: () => {
                    return notification.jobId;
                },
                candidateId: () => {
                    return notification.candidateId;
                },
                notificationId: () => {
                    return notification.notificationId;
                },
                headingTitle: () => {
                    return notification.highlightedHTMLText;
                }
            }
        });
        resumeProcessedModal.result.then(() => {
        }, () => {
        });
    }
    goToWorkflow($event, notification) {
        this.markNotificationAsRead($event, notification);
        // perform relevant actions as notification is clicked
        //Display processed resumes
        if (notification.eventType == 'JOB_SCORE_SYNC_COMPLETED') {
            this.$state.go('missioncontrol.candidateJobMatchesWorkflow', {
                jobId: notification.candidateDtoMap.reqId,
                searchString: ''
            });
            // this.$state.go('missioncontrol.uploadreq',
            //     {
            //         jobId: notification.candidateDtoMap.reqId,
            //         jobState: notification.candidateDtoMap.reqStatus,
            //         isNewReq: notification.candidateDtoMap.isNewReq,
            //         asyncActionType: notification.candidateDtoMap.actionType
            //     });
        }
        if (notification.eventType == 'RESUME_SCORE_SYNC_COMPLETED') {
            this.goToResumeProcessedCandidates(notification);
        }
        if (notification.eventType == 'JOB_BOARD_SEARCH_COMPLETED' || (notification.jbiTransactionId && notification.jbiTransactionId)) {
            // if jbiTransactionId exists and is not null, this notification was caused because a job board pull was finished.
            let actionType = 'reviewJobPull';
            let actionLabel = 'Review Job Board Pull';
            let closeCallback = null;
            switch (actionType) {
                case 'reviewJobPull':
                    closeCallback = () => {
                        if ((this.$state.current.name == 'missioncontrol.candidateJobMatchesWorkflow') && (notification.jobId == this.$state.params.jobId)) {
                            this.$rootScope.$broadcast('refreshJobWorkflow', null);
                        }
                    };
                    break;
                default:
                    break;
            }
            this.$uibModal.open({
                animation: false,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                template: UserNotificationActionModal.default,
                backdrop: 'static',
                keyboard: false,
                controller: ['$uibModalInstance', 'actionType', 'actionLabel', 'jobId', 'jbiTransactionId', 'notificationHTMLText', 'candidateDtoMap', 'notificationId', 'closeCallback', function ($uibModalInstance, actionType, actionLabel, jobId, jbiTransactionId, notificationHTMLText, candidateDtoMap, notificationId, closeCallback) {
                        let vm = this;
                        this.jobId = jobId;
                        this.jbiTransactionId = jbiTransactionId;
                        this.actionType = actionType;
                        this.actionLabel = actionLabel;
                        this.processedHTMLText = notificationHTMLText;
                        this.candidateDtoMap = candidateDtoMap;
                        this.notificationId = notificationId;
                        if (actionType == 'reviewJobPull') {
                            this.processedHTMLText = notificationHTMLText.replace(/Finished processing/g, "Processed");
                        }
                        this.saveCallback = () => {
                            $uibModalInstance.close('cancel');
                            saveCallback();
                        };
                        this.closeModal = () => {
                            $uibModalInstance.close('cancel');
                            if (!_.isNull(closeCallback)) {
                                closeCallback();
                            }
                        };
                        this.closeCallbackModal = () => {
                            $uibModalInstance.close('cancel');
                        };
                    }],
                windowTopClass: 'four-dot-five-modal-large',
                controllerAs: 'userNotificationsActionModal',
                size: 'lg',
                resolve: {
                    jobId: () => {
                        return notification.jobId;
                    },
                    jbiTransactionId: () => {
                        return notification.jbiTransactionId;
                    },
                    notificationHTMLText: () => {
                        return notification.highlightedHTMLText;
                    },
                    actionType: () => {
                        return actionType;
                    },
                    actionLabel: () => {
                        return actionLabel;
                    },
                    closeCallback: () => {
                        return closeCallback;
                    },
                    candidateDtoMap: () => {
                        return notification.candidateDtoMap;
                    },
                    notificationId: () => {
                        return notification.notificationId;
                    }
                }
            });
        }
        // view Generated PDF
        if (!_.isUndefined(notification.assessmentType) && !_.isNull(notification.assessmentType)) {
            this._showAssessmentReport(notification.jobMatchId, notification.assessmentType, notification.testInvitationId);
        }
        if (!_.isNull(notification.redirect) && !notification.documentDtoMap) {
            this.$state.go('missioncontrol.candidateJobMatchesWorkflow', {
                jobId: notification.redirect.jobId,
                searchString: notification.redirect.candidateEmail
            });
        }
        if (!_.isNull(notification.requisitionScreenRedirect) && notification.eventType === 'CANDIDATE_JOB_MATCH_RE_RUN_SCORING') {
            this.$state.go('missioncontrol.candidateJobMatchesWorkflow', {
                jobId: notification.requisitionScreenRedirect.jobId,
                searchString: notification.requisitionScreenRedirect.candidateEmail
            });
        }
        if (!_.isNull(notification.requisitionScreenRedirect) && notification.eventType === 'REQUISITION_RE_RUN_SCORING') {
            // this.$state.go('missioncontrol.requisitions', {
            //     userParamsObject: {
            //         requisitionNumber: notification.requisitionScreenRedirect.requisitionNumber
            //     }
            // });
            this.$state.go('missioncontrol.candidateJobMatchesWorkflow', {
                jobId: notification.requisitionScreenRedirect.jobId,
                searchString: ''
            });
        }
        // Redirect to Candidate Documents Tab
        if (notification.documentDtoMap) {
            this._goToCandidateDocuments(notification);
        }
        if (this.closeCallback) {
            this.closeCallback();
        }
    }
    goToCandidatesScreen($event, notification) {
        this.markNotificationAsRead($event, notification);
        let redirectInfo = notification.candidateScreenRedirect;
        if (redirectInfo) {
            let candidateType = redirectInfo.vendorCandidate ? "VENDOR_CANDIDATES" : "OWN_CANDIDATES";
            this.$state.go('missioncontrol.candidates', {
                searchString: redirectInfo.candidateEmail,
                candidateType: candidateType
            });
        }
        else {
            this.$state.go('missioncontrol.candidates', null);
        }
        if (this.closeCallback) {
            this.closeCallback();
        }
    }
    openResultsModal(event, notification, notificationIndex) {
        let tm = this;
        let candidateId = notification.candidateId ? notification.candidateId : notification.candidateOutreachJobMatchesInfo.candidateId;
        let candidateName = (notification.candidateOutreachJobMatchesInfo && notification.candidateOutreachJobMatchesInfo.candidateName) ? notification.candidateOutreachJobMatchesInfo.candidateName : null;
        let actionLabel = notificationIndex === 'candidateNoLongerMatch' ? 'Reasons for Candidate Mismatch' : `Job Matches ${candidateName ? "for <b>'" + candidateName + "'</b>" : ""}`;
        let actionType = notificationIndex === 'candidateNoLongerMatch' ? 'candidateNoLongerMatch' : 'outreachNoResponse';
        let windowClass = notificationIndex === 'candidateNoLongerMatch' ? 'four-dot-five-modal-small' : 'four-dot-five-modal-large';
        let isOutreachExpiryDataExists = notification.isOutreachExpiryDataExists;
        let allJobMatchesDisabled = tm.checkIfAllDisabled(notification.candidateOutreachJobMatchesInfo.jobMatches);
        let isSendOutreachAgainEnabled = notification.eventType.includes('REMINDER') || notification.eventType.includes('EXPIRY') || notification.eventType.includes('EXPIRED');
        this.$uibModal.open({
            animation: false,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: UserNotificationActionModal.default,
            backdrop: 'static',
            keyboard: false,
            controller: ['$uibModalInstance', 'actionType', 'actionLabel', 'notification', 'closeCallback', 'isStaffingCompany', 'jobTypeList', 'salaryDurationOptions', 'isOutreachExpiryDataExists', 'candidateId', 'selectAllJobMatches', 'allJobMatchesDisabled', 'isSendOutreachAgainEnabled',
                function ($uibModalInstance, actionType, actionLabel, notification, closeCallback, isStaffingCompany, jobTypeList, salaryDurationOptions, isOutreachExpiryDataExists, candidateId, selectAllJobMatches, allJobMatchesDisabled, isSendOutreachAgainEnabled) {
                    let vm = this;
                    this.actionType = actionType;
                    this.actionLabel = actionLabel;
                    '';
                    this.userNotificationControls = {};
                    this.userNotificationControls.setNewNotificationsAsViewed = null;
                    this.notification = notification;
                    this.isStaffingCompany = isStaffingCompany;
                    this.jobTypeList = jobTypeList;
                    this.salaryDurationOptions = salaryDurationOptions;
                    this.isOutreachExpiryDataExists = isOutreachExpiryDataExists;
                    this.candidateId = candidateId;
                    this.selectAllJobMatches = selectAllJobMatches;
                    this.allJobMatchesDisabled = allJobMatchesDisabled;
                    this.isSendOutreachAgainEnabled = isSendOutreachAgainEnabled;
                    this.closeModal = () => {
                        $uibModalInstance.close('cancel');
                    };
                    this.openModalCallback = (jobMatch) => {
                        tm.openModal(jobMatch, 'jobProfile', this.candidateId);
                    };
                    this.openJobCompareModalCallback = (jobMatch) => {
                        tm.openModal(jobMatch, 'jobCompare', this.candidateId);
                    };
                    this.onJobMatchSelectionChange = (jobMatches) => {
                        if (jobMatches && jobMatches.length > 0) {
                            const enabled = jobMatches.filter(jm => !jm.outreachDisabled);
                            this.selectAllJobMatches = enabled.length > 0 &&
                                enabled.every(jm => jm.jobMatchSelected === true);
                        }
                        else {
                            this.selectAllJobMatches = false;
                        }
                    };
                    this.toggleSelectAllJobMatches = (jobMatches) => {
                        if (jobMatches && jobMatches.length > 0) {
                            jobMatches.forEach(jm => {
                                jm.jobMatchSelected = !jm.outreachDisabled && this.selectAllJobMatches;
                            });
                        }
                    },
                        this.sendCandidateOutreachAgain = (jobMatches) => {
                            tm.sendSelectedJobMatchOutreachEmail(jobMatches, this.candidateId, this.notification.candidateType, this.notification.clientOrBuId, () => {
                                this.closeModal();
                            });
                        };
                }],
            windowTopClass: windowClass,
            controllerAs: 'userNotificationsActionModal',
            size: 'sm',
            resolve: {
                actionType: () => {
                    return actionType;
                },
                actionLabel: () => {
                    return actionLabel;
                },
                notification: () => {
                    return notification;
                },
                closeCallback: () => {
                    return this.init;
                },
                isStaffingCompany: () => {
                    return this.isStaffingCompany;
                },
                jobTypeList: () => {
                    return this.jobTypeList;
                },
                salaryDurationOptions: () => {
                    return this.salaryDurationOptions;
                },
                isOutreachExpiryDataExists: () => {
                    return isOutreachExpiryDataExists;
                },
                candidateId: () => {
                    return candidateId;
                },
                selectAllJobMatches: () => {
                    return false;
                },
                allJobMatchesDisabled: () => {
                    return allJobMatchesDisabled;
                },
                isSendOutreachAgainEnabled: () => {
                    return isSendOutreachAgainEnabled;
                }
            }
        });
        this.$timeout(() => {
            // Nested Modal Issue - To be fixed in future
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            $(".modal").addClass("user-notifications-modal-large");
            $(".modal.four-dot-five-modal-small.in").removeClass("user-notifications-modal-large");
        }, 1);
    }
    _getHighlightedNotificationHTML(text) {
        let newText = text.replace(/<4dot5>/g, "<span class='emerald'>");
        return newText ? newText.replace(/<\/4dot5>/g, "</span>") : "";
    }
    _getClientsOrBus(successCallback) {
        this.loadingClientsOrBUs = true;
        let requisitionId = null;
        let isFromCreateReq = false;
        this.requisitionService.getAllClientsOrBu(this.$rootScope.userDetails, requisitionId, isFromCreateReq, (data) => {
            this._setClientsOrBus(data);
            this.loadingClientsOrBUs = false;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.loadingClientsOrBUs = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _setClientsOrBus(clientsOrBus) {
        this.fullClientsList = clientsOrBus;
        angular.forEach(this.fullClientsList, (clientOrBu, key) => {
            if (clientOrBu.companyType == 'Corporation') {
                clientOrBu.name = "<span style='padding-right:5px;'>" + clientOrBu.name + "</span><i class='fas fa-share-alt'></i>";
            }
        });
        this.fullClientsListCopy = angular.copy(this.fullClientsList);
        // if(this.savedFilters !== null){
        //     this.selectedClients = this.fullClientsList.filter(clientOrBu => this.savedFilters.clientOrBU.some(selectedId => clientOrBu.id == selectedId));
        //     this.selectedClients.forEach(clientOrBu => clientOrBu.ticked = true);
        // }
    }
    onClientClick() {
        this._getRoles("all", () => {
            this.getRequisitionNumbers("all", () => {
                this.searchNotifications();
            });
        });
    }
    onRoleClick() {
        this.getRequisitionNumbers("all", () => {
            this.searchNotifications();
        });
    }
    onRequisitionNumberClick() {
        this.searchNotifications();
    }
    _getRoles(searchReqText, successCallback) {
        this.loadingRoles = true;
        this.fullRolesList = [];
        this.selectedRoles = [];
        if (searchReqText == "" || !angular.isDefined(searchReqText)) {
            searchReqText = "all";
        }
        else {
            this.searchReqText = searchReqText;
        }
        let clientOrBuIds = this.selectedClients.map(clientOrBu => clientOrBu.id);
        this.jobService.getRoles(this.userId, this.companyId, this.searchReqText, { clientOrBuIds: clientOrBuIds }, (data) => {
            this._setRoles(data);
            this.loadingRoles = false;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.loadingRoles = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _setRoles(roles) {
        angular.forEach(roles, (val, key) => {
            let roleObj = { "name": val };
            if (!this._containsObject(roleObj, this.fullRolesList, "name")) {
                if (val !== null)
                    roleObj.selectedDisplayName = this.$filter('displayOnMultiSelectFilter')(val);
                this.fullRolesList.push(roleObj);
            }
            this.fullRolesListCopy = angular.copy(this.fullRolesList);
        });
        // if(this.savedFilters !== null){
        //     this.selectedRoles = this.fullRolesList.filter(role => this.savedFilters.roleList.some(roleName => role.name == roleName));
        //     this.selectedRoles.forEach(role => role.ticked = true);
        // }
    }
    getRequisitionNumbers(searchReqText, successCallback) {
        this.loadingRequisitionNumbers = true;
        this.fullReqNumList = [];
        this.selectedRequisitionNumbers = [];
        if (searchReqText == "" || !angular.isDefined(searchReqText)) {
            searchReqText = "all";
        }
        this.searchReqText = searchReqText;
        let clientOrBuIds = this.selectedClients.map(clientOrBu => clientOrBu.id);
        let roleNames = this.selectedRoles.map(role => role.name);
        let reqNumberFilter = { clientOrBuIds: clientOrBuIds, roleNames: roleNames };
        this.jobService.searchByReqNum(this.userId, this.companyId, this.searchReqText, reqNumberFilter, (data) => {
            this._setRequisitionNumbers(data);
            if (searchReqText == "all") {
                this.fullReqNumListCopy = angular.copy(this.fullReqNumList);
            }
            this.loadingRequisitionNumbers = false;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.loadingRequisitionNumbers = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _setRequisitionNumbers(requisitionNumbers) {
        let modifiedRequisitionNumbers = [];
        for (let i = 0; i < requisitionNumbers.length; i++) {
            let icon = requisitionNumbers[i].sharedRequisition ? '<i class="fas fa-share-alt"></i> ' : '<span class="pl-4"></span>';
            let obj = { name: requisitionNumbers[i].reqNumber, icon: icon };
            // if(!this._containsObject(obj, modifiedRequisitionNumbers, "name")) {
            obj.selectedDisplayName = this.$filter('displayOnMultiSelectFilter')(obj.name);
            modifiedRequisitionNumbers.push(obj);
            // }
        }
        for (let i = 0; i < modifiedRequisitionNumbers.length; i++) {
            for (let j = 0; j < this.selectedRequisitionNumbers.length; j++) {
                if (modifiedRequisitionNumbers[i].name == this.selectedRequisitionNumbers[j].name) {
                    modifiedRequisitionNumbers[i]['ticked'] = true;
                    break;
                }
            }
        }
        this.fullReqNumList = angular.copy(modifiedRequisitionNumbers);
        // if(this.savedFilters !== null){
        //     this.selectedRequisitionNumbers = this.fullReqNumList.filter(reqNumber => this.savedFilters.requisitionNums.some(num => num == reqNumber.name));
        //     this.selectedRequisitionNumbers.forEach(num => num.ticked = true);
        // }
    }
    selectRemoveAll(label, type) {
        this._setFiltersAndFetchJobs(label, type);
    }
    _setFiltersAndFetchJobs(label, type) {
        if (type === 'selectAll') {
            if (label === this.MESSAGECONSTANTS.LABLES.CLIENT || label === this.MESSAGECONSTANTS.LABLES.BU) {
                this.selectedClients = [...this.fullClientsList];
                this.onClientClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.USER_MANAGEMENT.ROLE) {
                this.selectedRoles = [...this.fullRolesList];
                this.onRoleClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.REQ_NUMBER) {
                this.selectedRequisitionNumbers = [...this.fullReqNumList];
                this.onRequisitionNumberClick();
            }
        }
        else {
            if (label === this.MESSAGECONSTANTS.LABLES.CLIENT || label === this.MESSAGECONSTANTS.LABLES.BU) {
                this.fullClientsList.forEach(clientOrBU => clientOrBU.ticked = false);
                this.selectedClients = [];
                this.onClientClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.USER_MANAGEMENT.ROLE) {
                this.fullRolesList.map(role => role.ticked = false);
                this.selectedRoles = [];
                this.onRoleClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.REQ_NUMBER) {
                this.fullReqNumList.map(num => num.ticked = false);
                this.selectedRequisitionNumbers = [];
                this.onRequisitionNumberClick();
            }
        }
    }
    _containsObject(obj, list, key) {
        for (var index in list) {
            var currentObject = list[index];
            for (var prop in currentObject) {
                if (prop === key && currentObject.hasOwnProperty(prop)
                    && currentObject[prop] === obj[prop]) {
                    return true;
                }
            }
        }
        return false;
    }
    getNotificationTypes() {
        this.loadingNotificationTypes = true;
        this.notificationsService.getNotificationTypes((data) => {
            this.alertTypes = data;
            this.loadingNotificationTypes = false;
        }, (error) => {
            this.loadingNotificationTypes = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    openModal(jobMatch, actionType, candidateId) {
        let actionLabel = actionType === 'jobProfile' ? 'Job Profile' : 'Candidate Job Comparison';
        this.$uibModal.open({
            animation: false,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: UserNotificationActionModal.default,
            backdrop: 'static',
            keyboard: false,
            controller: ['$uibModalInstance', 'actionType', 'actionLabel', 'notification', 'candidateId', function ($uibModalInstance, actionType, actionLabel, notification, candidateId) {
                    let vm = this;
                    this.actionType = actionType;
                    this.actionLabel = actionLabel;
                    this.notification = notification;
                    this.candidateId = candidateId;
                    this.closeModal = () => {
                        $uibModalInstance.close('cancel');
                    };
                }],
            windowTopClass: 'four-dot-five-modal-large',
            controllerAs: 'userNotificationsActionModal',
            size: 'sm',
            resolve: {
                actionType: () => {
                    return actionType;
                },
                actionLabel: () => {
                    return actionLabel;
                },
                notification: () => {
                    return jobMatch;
                },
                candidateId: () => {
                    return candidateId;
                },
                closeCallback: () => {
                    return this.init;
                }
            }
        });
        // this.$timeout(() => {
        //     // Nested Modal Issue - To be fixed in future
        //     this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        //     $(".modal").addClass("user-notifications-modal-large");
        //     $(".modal.four-dot-five-modal-small.in").removeClass("user-notifications-modal-large");
        // }, 1);
    }
    checkIfAllDisabled(jobMatches) {
        if (!jobMatches || jobMatches.length === 0) {
            return true;
        }
        return jobMatches.every(jm => jm.outreachDisabled === true);
    }
    ;
    sendSelectedJobMatchOutreachEmail(jobMatches, candidateId, candidateType, clientOrBuId, successCallback) {
        const selectedJobMatches = jobMatches.filter(jobMatch => (jobMatch.jobMatchSelected && !jobMatch.outreachDisabled));
        if (selectedJobMatches.length === 0) {
            this.alertsAndNotificationsService.showAlert('No Selection', 'Please select at least One Job Match to Send Outreach to Candidate.', 'warning');
            return;
        }
        else {
            let outreachObject = {};
            let candidateIds = [
                {
                    id: candidateId,
                    candidateType: candidateType ? candidateType : 'OWN_CANDIDATES',
                    source: 'CANDIDATE_CARD',
                    jobIds: jobMatches.filter(jobMatch => (jobMatch.jobMatchSelected && !jobMatch.outreachDisabled)).map(jobMatch => jobMatch.jobId),
                    jobMatchId: ""
                }
            ];
            outreachObject = {
                candidates: candidateIds,
                userId: this.userId,
                companyId: this.companyId,
                clientOrBuId: clientOrBuId ? clientOrBuId : jobMatches[0].clientOrBuId ? jobMatches[0].clientOrBuId : ''
            };
            this.candidateService.sendOutreachEmail(outreachObject, (data) => {
                this.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
                if (successCallback) {
                    successCallback();
                }
            }, (error) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    }
}
class SearchObject {
    constructor(companyId, showFilters) {
        this.companyId = companyId;
        this.page = "";
        this.size = 3;
        this.notifyOn = 'GLOBAL';
        if (showFilters) {
            this.alertType = null;
            this.startDateTime = null;
            this.endDateTime = null;
            this.firstName = null;
            this.lastName = null;
            this.jobTitle = null;
            this.clientName = null;
            this.requisitionNumber = null;
            this.onlyUnreadNotifications = false;
            clientOrBuIds = [];
            roleNames = [];
            reqNumbers = [];
        }
    }
}
UserNotificationsController.$inject = ['$rootScope', '$state', '$filter', '$uibModal', '$timeout', 'StorageService', 'planService', 'companyService', 'requisitionService', 'jobService', 'userRoleService', 'utilityService', 'debounceService', 'alertsAndNotificationsService', 'webSocketsService', 'dateTimeUtilityService', 'MESSAGECONSTANTS', 'notificationsService', 'sharedAjsService', 'modalService', 'outreachService', 'candidateService'];
// import * as TEMPLATE from '.user-notifications.html';
import * as TEMPLATE from 'raw-loader!./user-notifications.html';
export const UserNotificationsComponent = {
    selector: 'userNotifications',
    component: {
        bindings: {
            height: '@',
            width: '@',
            numberOfNewNotifications: '=',
            searchObject: '@',
            viewAllFlag: '@',
            viewAllMode: '@',
            context: '@',
            userNotificationControls: '=',
            showFilters: '<',
            showShortNotification: '=',
            notificationClicked: '<',
            fullView: '<',
            closeCallback: '&',
            jobTypeList: '<',
            salaryDurationOptions: '<'
        },
        template: TEMPLATE.default,
        controller: UserNotificationsController
        // templateUrl: 'app/shared/userNotifications/user-notifications.html'
    }
};
class NotificationsContainer {
    constructor($rootScope, context, showShortNotification, searchObject, showFilters, fullView, alertsAndNotificationsService, notificationsService, isStaffingCompany, outreachService) {
        this.$rootScope = $rootScope;
        this.context = context;
        this.showShortNotification = showShortNotification;
        this.searchObject = searchObject;
        this.showFilters = showFilters;
        this.fullView = fullView;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.notificationsService = notificationsService;
        this.isStaffingCompany = isStaffingCompany;
        this.outreachService = outreachService;
        this.$onInit();
    }
    $onInit() {
        this.notifications = [];
        this.newNotifications = [];
        this.busy = false;
        this.isNotificationIconClicked = false;
        this.notificationsExistFlag = true;
        this.searchObject = _.isUndefined(this.searchObject) ? new SearchObject(this.$rootScope.userDetails.company.companyId, this.showFilters) : (_.isObject(this.searchObject) ? this.searchObject : JSON.parse(this.searchObject));
        this.currentPromise = null;
        this.disableInfiniteScroll = false;
        this.isFilterOn = false;
        this.selectAll = false;
        this.originalNotificationCount = 0;
        this.filteredNotificationCount = 0;
    }
    getNext(parentRef) {
        if (this.busy) {
            // getNext: Already busy, returning early
            return;
        }
        this.busy = true;
        if (this.searchObject.page == '') {
            this.searchObject.page = 1;
        }
        this.searchObject.companyId = this.$rootScope.userDetails.company.companyId;
        //Avoid page 1 being called the second time when the notifications on the card is clicked and expanded
        if (this.searchObject.page == 1 && this.notifications.length > 0) {
            this.searchObject.page = 2;
        }
        let tempSearchObject = angular.copy(this.searchObject);
        this._setIsFilterOn();
        this.currentPromise = this.notificationsService.getNotifications(tempSearchObject, (data) => {
            if (angular.isDefined(data) && data != 'user cancellation' && angular.isDefined(data.notifications)) {
                // Track unfiltered count before applying global filter
                const originalCount = data.notifications.length;
                if (data.notifications.length > 0) {
                    if (this.context == 'global') {
                        data.notifications = data.notifications.filter(notification => {
                            if (notification.notifyOn) {
                                return notification.notifyOn.indexOf('NO_GLOBAL') == -1;
                            }
                            else {
                                return true;
                            }
                        });
                    }
                    parentRef.numberOfNewNotifications = data.unreadNotificationCount;
                    angular.forEach(data.notifications, (val, key) => {
                        val = this.massageMessageData(val);
                        // push new notifications into the new notifications array
                        if (val.state == 'NEW' || val.state == 'VIEWED') {
                            this.newNotifications.push(val);
                        }
                        //handle duplicate if notification is already got from web socket
                        if (val.operation == 'new') {
                            let index = _.findIndex(this.notifications, {
                                notificationId: this.notificationId
                            });
                            if (index == -1) {
                                this.notifications.push(val);
                            }
                        }
                        else {
                            this.notifications.push(val);
                        }
                    });
                    console.log('Notification Icon clicked: ' + this.isNotificationIconClicked);
                    if (this.searchObject.page > 1 && this.isNotificationIconClicked) {
                        this.setNewNotificationsAsViewed();
                    }
                    // if the length of the returned values is less than page size, it means there are not enough values.
                    // hence we can disable the infinite scroll
                    if ((!this.fullView && !this.isNotificationIconClicked) || (originalCount < this.searchObject.size)) {
                        this.disableInfiniteScroll = true;
                    }
                    else {
                        this.disableInfiniteScroll = false;
                        this.searchObject.page++;
                    }
                    this.originalNotificationCount = originalCount;
                    this.filteredNotificationCount = data.notifications.length;
                    this.notificationCalledOnce++;
                }
                else {
                    // if the length of the returned values is 0, it means there are no more values.
                    // hence we can disable the infinite scroll
                    this.disableInfiniteScroll = true;
                }
                // set the notifications exist flag based on existence of notifications.
                if (this.notifications.length > 0) {
                    this.notificationsExistFlag = true;
                }
                else {
                    this.notificationsExistFlag = false;
                }
            }
            //set this.busy to false
            this.busy = false;
        }, (error) => {
            // getNext: Error callback, setting busy to false. Error:
            this.busy = false;
            // Disable infinite scroll on error to prevent continuous retry
            this.disableInfiniteScroll = true;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            this.busy = false;
        });
    }
    _setIsFilterOn() {
        let filter = this.searchObject;
        if ((filter.clientOrBuIds !== undefined && filter.clientOrBuIds.length > 0)
            || (filter.reqNumbers !== undefined && filter.reqNumbers.length > 0)
            || (filter.roleNames !== undefined && filter.roleNames.length > 0)
            || (filter.alertType !== undefined && filter.alertType.length > 0)
            || (filter.firstName !== undefined && filter.firstName.length > 0)
            || (filter.lastName !== undefined && filter.lastName.length > 0)) {
            this.isFilterOn = true;
        }
        else {
            this.isFilterOn = false;
        }
    }
    massageMessageData(message) {
        if (_.isNull(message.state)) {
            message.state = 'NEW';
        }
        if (message.candidateDtoMap) {
            let date = moment(message.createdDate).format("MMM DD, YYYY hh:mm A");
            message.taggedText = `${message.taggedText.split('at <4dot5>')[0]} at <4dot5>'${date}'</4dot5>`;
        }
        message.createdDate = new Date(message.createdDate);
        message.selectedFlag = this.selectAll;
        if (!_.isNull(message.taggedText)) {
            message.highlightedHTMLText = this._getHighlightedNotificationHTML(message.taggedText);
        }
        else {
            message.highlightedHTMLText = message.text;
        }
        message.showShortMessageFlag = this.showShortMessagesFlag;
        message.showRedirect = false;
        message.showCandidateScreenRedirect = false;
        if (!_.isNull(message.redirect) && message.redirect.screenName == 'CANDIDATE_WORKFLOW' && !_.isNull(message.redirect.candidateName)) {
            message.showRedirect = true;
        }
        if ((!_.isUndefined(message.jbiTransactionId) && !_.isNull(message.jbiTransactionId)) || (!_.isUndefined(message.assessmentType) && !_.isNull(message.assessmentType))) {
            message.showRedirect = true;
        }
        if (!_.isNull(message.candidateScreenRedirect) && message.candidateScreenRedirect !== undefined && this.context == 'global') {
            message.showCandidateScreenRedirect = true;
        }
        if (!message.candidateScreenRedirect && (this.context == 'global' && (message.eventType && message.eventType === 'COMPANY_RE_RUN_SCORING'))) {
            message.showCandidateScreenRedirect = true;
        }
        if ((message.candidateDtoMap || message.documentDtoMap) && (message.eventType && !message.eventType.includes('RE_RUN_SCORING'))) {
            message.showRedirect = true;
        }
        if (message.requisitionScreenRedirect) {
            message.showRedirect = true;
        }
        if (message.reasons && message.reasons.length > 0 && message.eventType.includes('CANDIDATE_NO_LONGER_MATCHES')) {
            message.reasons = message.reasons.map(reason => {
                const matches = reason.match(/<4dot5>(.*?)<\/4dot5>/g);
                if (matches && matches.length > 0) {
                    for (let i = 0; i < matches.length; i++) {
                        const fullTag = matches[i]; // match with <4dot5>2025-10-07T12:20:29.760Z</4dot5>
                        const value = fullTag.replace(/<\/?4dot5>/g, ''); // extract inner value
                        // Check if it's a valid ISO date
                        if (moment(value, moment.ISO_8601, true).isValid()) {
                            const formatted = moment(value).format('MMM D, YYYY h:mm A');
                            reason = reason.replace(fullTag, '<4dot5>' + formatted + '</4dot5>');
                        }
                    }
                }
                return this._getHighlightedNotificationHTML(reason);
            });
            message.showNoLongerMatchResults = true;
        }
        const outreachEventTypes = [
            "OUTREACH_SAVED",
            "OUTREACH_COMPLETED",
            "OUTREACH_SENT",
            "OUTREACH_NO_RESPONSE_EXPIRED",
            "OUTREACH_RESPONSE_EXPIRED",
            "OUTREACH_NOT_COMPLETED_EXPIRED",
            "OUTREACH_COMPLETION_EXPIRED",
            "OUTREACH_RESPONSE_REMINDER",
            "OUTREACH_COMPLETION_REMINDER"
        ];
        if (outreachEventTypes.includes(message.eventType) && message.candidateOutreachJobMatchesInfo) {
            if (typeof message.candidateOutreachJobMatchesInfo === 'string') {
                message.candidateOutreachJobMatchesInfo = JSON.parse(message.candidateOutreachJobMatchesInfo);
            }
            if (message.candidateOutreachJobMatchesInfo.jobMatches && message.candidateOutreachJobMatchesInfo.jobMatches.length > 0) {
                message.showOutreachNoResponseIcon = true;
                this.setOutreachJobMatchDetails(message);
            }
        }
        return message;
    }
    _getHighlightedNotificationHTML(text) {
        let newText = text.replace(/<4dot5>/g, "<span class='emerald'>");
        return newText ? newText.replace(/<\/4dot5>/g, "</span>") : '';
    }
    setNewNotificationsAsViewed() {
        if (this.showShortNotification) {
            this._setNotificationsAsShort();
        }
        this.isNotificationIconClicked = true;
        console.log('Set this.setNewNotificationsAsViewed() called');
        if (this.newNotifications.length > 0) {
            let stateObject = {
                notificationIds: [],
                state: 'VIEWED'
            };
            angular.forEach(this.newNotifications, (val, key) => {
                stateObject.notificationIds.push(val.notificationId);
            });
            this.notificationsService.setNotificationsState(stateObject, (data) => {
                // do nothing. notification state change will be received as a push update and be handled in the this._initializeNotificationReceive above.
            }, (error) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    }
    _setNotificationsAsShort() {
        angular.forEach(this.notifications, (notification, key) => {
            notification.showShortMessageFlag = true;
        });
    }
    setOutreachJobMatchDetails(message) {
        message.candidateOutreachJobMatchesInfo.jobMatches.forEach(jobMatch => {
            this.outreachService.setCompanyLocationLabel(jobMatch, this.isStaffingCompany);
            jobMatch.missingOrNonMatched = this.outreachService.setMissedOrMatchedInfo(jobMatch.missingOrNonMatchedInfo, jobMatch.workLocations);
            jobMatch.formattedOutreachStatus = this.outreachService.formatOutreachStatus(jobMatch.outreachStatus);
            jobMatch.jobDetails = this.outreachService.setJobDetailsLabel(jobMatch, this.jobTypeList, this.salaryDurationOptions);
            jobMatch.daysSinceOutreach = this.outreachService.setDaysSinceOutreach(jobMatch);
            jobMatch.candidateMatch = this.outreachService.setCandidateMatchingLabel(jobMatch);
            jobMatch.outreachExpiryDate = this.outreachService.setOureachExpiryDate(jobMatch, message);
            jobMatch.isScoreMatched = (jobMatch.score && jobMatch.thresholdScore) ? jobMatch.score >= jobMatch.thresholdScore : false;
        });
        message.isOutreachExpiryDataExists = message.eventType.includes('EXPIRY') || message.candidateOutreachJobMatchesInfo.jobMatches.some(jm => jm.outreachExpiryDate);
    }
}
//# sourceMappingURL=user-notifications.component.js.map